export const enum AutocompleteCacheChecksumKeysEnum {
  locations = 'autocomplete_location_checksum',
  brokers = 'autocomplete_broker_checksum',
  agents = 'autocomplete_agent_checksum',
}
